import React, { useMemo, useReducer } from "react";
import { timestampsHandlers, timestampsInitialState, timestampsReducer } from "../reducers/TimestampsReducer";

export const TimestampsContext = React.createContext()

export default function TimestampsProvider(props) {

  const init_state = {}

  const [timestamps_state, timestamps_dispatch] = useReducer(timestampsReducer, init_state, timestampsInitialState)
  const timestamps_handlers = useMemo(
    () => timestampsHandlers(timestamps_dispatch),
    [timestamps_dispatch]
  );

  return <TimestampsContext.Provider
    value={{ timestamps_state, timestamps_handlers }}>
    {props.children}
  </TimestampsContext.Provider>
}